import { render, staticRenderFns } from "./figment-drawer.vue?vue&type=template&id=4016502d&scoped=true&"
import script from "./figment-drawer.vue?vue&type=script&lang=js&"
export * from "./figment-drawer.vue?vue&type=script&lang=js&"
import style0 from "./figment-drawer.vue?vue&type=style&index=0&id=4016502d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4016502d",
  null
  
)

export default component.exports